module.exports = __webpack_public_path__ + "img/1576598419.c16ea324.jpg";